import React from "react";
import CPBoardView from "../components/CPBoardView";
import { Container } from "@amzn/awsui-components-react";

const ATeamResourcesPage = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CPBoardView
      pageType="ATEAM Resources"
      tabType="BOARD"
      owner={selectedCPView}
      viewAccess={viewAccess}
      addOrEditAccess={addOrEditAccess}
    />
  </Container>
);

export default ATeamResourcesPage;
